//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import Requisites from './Requisites/StatisticsRequisitesRequisites.vue';
import Users from './RequisiteUser/StatisticsRequisitesUsers.vue';
import GetReport from '~/components/GetReport.vue';
import constant from '~/const';

export default {
  data() {
    return {
      constant,
    };
  },

  components: { Requisites, Users, GetReport },

  async mounted() {
    this.setGeneralLoader(true);
    await this.loadRequisites();
    await this.loadDataAction();
    this.setGeneralLoader(false);
  },

  computed: {
    ...mapState('common', ['generalLoader']),
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
    ]),
    ...mapActions('tradersRequisites', {
      loadRequisites: 'loadData',
    }),
    ...mapActions('statisticsRequisiteUser', {
      loadDataAction: 'loadData',
    }),
  },
};

